const ES = {
  custom: {
    nit: {
      required: "Ingrese el nit de la empresa"
    },
    name: {
      required: "Ingrese el nombre de la empresa"
    },
    email: {
      required: "Ingrese el email",
      email: "Email no válido (ejemplo@dominio.com)"
    },
    address: {
      required: "Ingrese la dirección"
    },
    contactPerson: {
      required: "Ingrese el nombre de contacto"
    },
    phone: {
      required: "Ingrese el número de celular"
    },
    cityID: {
      required: "Seleccione la ciudad"
    },
    localeID: {
      required: "Seleccione el idioma"
    },
    dispatchKey: {
      required: "*Favor ingrese el Token del API.",
      min: "El token debe ser mínimo de 20 carácteres",
      max: "El token debe ser máximo de 32 carácteres"
    },
    dispatchUrl: {
      required: "*Favor ingrese la url del API.",
      url: "Debe ser de carácter url con protocolo https://."
    }
  }
};

const EN = {
  custom: {
    nit: {
      required: "Enter the nit of the company"
    },
    name: {
      required: "Enter company name"
    },
    email: {
      required: "Enter the email",
      email: "Invalid email (example@domain.com)"
    },
    address: {
      required: "Enter the address"
    },
    contactPerson: {
      required: "Enter contact name"
    },
    phone: {
      required: "Enter the mobile number"
    },
    cityID: {
      required: "Select the city"
    },
    localeID: {
      required: "Select language"
    },
    dispatchKey: {
      required: "*Please enter the API Token.",
      min: "The token must be a minimum of 20 characters",
      max: "The token must be a maximum of 32 characters"
    },
    dispatchUrl: {
      required: "*Please enter the API url.",
      url: "It must be of url character with https:// protocol."
    }
  }
};

const PT = {
  custom: {
    nit: {
      required: "Enter the nit of the company"
    },
    name: {
      required: "Enter company name"
    },
    email: {
      required: "Enter the email",
      email: "Invalid email (example@domain.com)"
    },
    address: {
      required: "Enter the address"
    },
    contactPerson: {
      required: "Enter contact name"
    },
    phone: {
      required: "Enter the mobile number"
    },
    cityID: {
      required: "Select the city"
    },
    localeID: {
      required: "Select language"
    },
    dispatchKey: {
      required: "*Please enter the API Token.",
      min: "The token must be a minimum of 20 characters",
      max: "The token must be a maximum of 32 characters"
    },
    dispatchUrl: {
      required: "*Please enter the API url.",
      url: "It must be of url character with https:// protocol."
    }
  }
};

export { ES, EN, PT };

